'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _debugger = require('../../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Component that loads a media player library, designated by its libraryUrl
 * property which is set by classes that extend this one.
 */
var LibraryLoader = function () {
  function LibraryLoader() {
    (0, _classCallCheck3.default)(this, LibraryLoader);

    this.libraryUrl = null;
  }
  /**
   * This .getPlayerLibrary should be overridden by classes that extend
   * LibraryLoader. This method is used to check if the given
   * media player library was able to be loaded. It's used in the
   * .getLibrary method below.
   * @returns {null}
   */


  (0, _createClass3.default)(LibraryLoader, [{
    key: 'getPlayerLibrary',
    value: function getPlayerLibrary() {
      return null;
    }

    /**
     * Method to manage the loading of a remote media library. If no
     * libraryUrl was passed to the LibraryLoader constructor then
     * this method will always return null.
     *
     * .getLibrary makes use of the overridden .getPlayerLibrary method to
     * check to see if the media library was loaded successfully and if the
     * media player was able to be created.
     *
     * This method tries to load the external media library script three times
     * before it fails and returns null.
     * @param attempts
     * @returns {Promise}
     */

  }, {
    key: 'getLibrary',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var attempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var player, nextAttempt;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _debugger2.default.log('loading player library: ' + this.libraryUrl + ' (attempts: ' + attempts + ')');

                if (this.libraryUrl) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', this.getPlayerLibrary());

              case 3:
                if (!(attempts >= 3)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', null);

              case 5:
                player = this.getPlayerLibrary();

                if (!player) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', player);

              case 8:
                _context.next = 10;
                return this.loadPlayerLibrary();

              case 10:
                nextAttempt = attempts + 1;
                _context.next = 13;
                return this.getLibrary(nextAttempt);

              case 13:
                return _context.abrupt('return', _context.sent);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLibrary() {
        return _ref.apply(this, arguments);
      }

      return getLibrary;
    }()

    /**
     * Method that appends a script tag to the head of the document, and tries to
     * load the media player library that is designated by the libraryUrl argument that
     * is passed to the LibraryLoader's constructor.
     * @returns {Promise} - resolves if the script was loaded successfully or rejects
     * if it doesn't.
     */

  }, {
    key: 'loadPlayerLibrary',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this = this;

        var loading;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /* eslint-disable no-undef */
                loading = new _promise2.default(function (resolve, reject) {
                  var head = document.getElementsByTagName('head')[0];
                  var script = document.createElement('script');
                  script.type = 'text/javascript';
                  script.src = _this.libraryUrl;
                  script.onerror = reject;
                  script.onload = resolve;
                  // IE6, 7 and 8 only support an onreadystatechange handler to signify that
                  // a script has successfully loaded.
                  //
                  // Documentation:
                  //  https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement#See_also
                  //  https://pie.gd/test/script-link-events/
                  script.onreadystatechange = resolve;
                  head.appendChild(script);
                });
                _context2.prev = 1;
                _context2.next = 4;
                return loading;

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6]]);
      }));

      function loadPlayerLibrary() {
        return _ref2.apply(this, arguments);
      }

      return loadPlayerLibrary;
    }()
  }]);
  return LibraryLoader;
}();

exports.default = LibraryLoader;
//# sourceMappingURL=LibraryLoader.js.map